import { render, staticRenderFns } from "./LocationMarker.vue?vue&type=template&id=52c7211c&scoped=true&"
import script from "./LocationMarker.vue?vue&type=script&lang=ts&"
export * from "./LocationMarker.vue?vue&type=script&lang=ts&"
import style0 from "./LocationMarker.vue?vue&type=style&index=0&id=52c7211c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c7211c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
